/**
 * Story edit link
 * @author Ryan Gladstone
 * <story-edit-link url="story.cmsEditURL"></story-edit-link>
 */

function storyEditLink() {
  return {
    restrict: 'E',
    scope: {
      url: '='
    },
    template: `<a ng-href="{{::url}}" target="_blank" rel="noopener noreferrer">
        <button class="btn mr1" twp-translate>
          OPEN_IN_EDITOR
        </button>
      </a>`
  };
}

export default function (ngModule) {
  ngModule.directive('storyEditLink', storyEditLink);
}
